import { render, staticRenderFns } from "./BaseTitleBarScrollPage.vue?vue&type=template&id=4851c5ed&scoped=true"
import script from "./BaseTitleBarScrollPage.vue?vue&type=script&lang=js"
export * from "./BaseTitleBarScrollPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4851c5ed",
  null
  
)

export default component.exports